/** Country/region data for location dropdowns (aligned with internal-web) */
export const citiesByCountry: Record<string, string[]> = {
  Chile: [
    'Santiago',
    'Valparaíso',
    'Viña del Mar',
    'Concepción',
    'La Serena',
    'Antofagasta',
    'Temuco',
    'Puerto Montt',
    'Iquique',
    'Rancagua',
    'Talca',
    'Arica',
    'Copiapó',
    'Punta Arenas',
    'Chillán',
  ],
  Brazil: [
    'São Paulo',
    'Rio de Janeiro',
    'Brasília',
    'Salvador',
    'Fortaleza',
    'Belo Horizonte',
    'Curitiba',
    'Manaus',
    'Recife',
    'Porto Alegre',
    'Belém',
    'Goiânia',
    'Campinas',
    'São Luís',
    'Natal',
  ],
  'United States': [
    'New York',
    'Los Angeles',
    'Chicago',
    'Houston',
    'Phoenix',
    'Philadelphia',
    'San Antonio',
    'San Diego',
    'Dallas',
    'San Jose',
    'Austin',
    'Miami',
    'Seattle',
    'Denver',
    'Boston',
    'Atlanta',
  ],
  'United Kingdom': [
    'London',
    'Manchester',
    'Birmingham',
    'Leeds',
    'Glasgow',
    'Liverpool',
    'Bristol',
    'Edinburgh',
    'Sheffield',
    'Cardiff',
  ],
  Australia: [
    'Sydney',
    'Melbourne',
    'Brisbane',
    'Perth',
    'Adelaide',
    'Canberra',
    'Gold Coast',
    'Newcastle',
    'Hobart',
    'Darwin',
  ],
  India: [
    'Mumbai',
    'Delhi',
    'Bengaluru',
    'Hyderabad',
    'Chennai',
    'Kolkata',
    'Pune',
    'Ahmedabad',
    'Jaipur',
    'Surat',
  ],
};

export const COUNTRY_OPTIONS = [
  { value: 'US', label: 'United States' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'AU', label: 'Australia' },
  { value: 'IN', label: 'India' },
  { value: 'CL', label: 'Chile' },
  { value: 'BR', label: 'Brazil' },
];
